export default {"src":"/_next/static/media/neutralInactive_24.946f21f6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};